function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import i18n from 'i18next';
import { Option } from 'components/Select';
import ShadedCard from 'components/ShadedCard';
import Box from 'components/Box';
import Heading from 'components/Heading';
import Stack from 'components/Stack';
import { TeamPill, UserPill } from 'components/Pill';
import InlineList from 'components/InlineList';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var attendeeStatusOptions = ['booked', 'cancelled', 'attended', 'noshow'];
export function isAttendeeStatus(value) {
  return Boolean(value && attendeeStatusOptions.includes(value));
}
function getStatusLabel(status) {
  var labels = {
    booked: i18n.t('state_booked'),
    attended: i18n.t('state_attended'),
    cancelled: i18n.t('state_cancelled'),
    noshow: i18n.t('state_no_show')
  };
  return labels[status];
}
export function renderAttendeeStatusOptions() {
  return attendeeStatusOptions.map(function (status) {
    return /*#__PURE__*/_jsx(Option, {
      value: status,
      children: getStatusLabel(status)
    }, status);
  });
}
function groupConflictUsersByTeam(conflictUsers, teams) {
  var teamMap = new Map(teams.map(function (t) {
    return [t.id, t];
  }));
  var groups = new Map();
  var _iterator = _createForOfIteratorHelper(conflictUsers),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _user$teamIds;
      var user = _step.value;
      var _iterator2 = _createForOfIteratorHelper((_user$teamIds = user.teamIds) !== null && _user$teamIds !== void 0 ? _user$teamIds : []),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _groups$get;
          var teamId = _step2.value;
          var team = teamMap.get(teamId);
          if (!team) continue;
          var group = (_groups$get = groups.get(teamId)) !== null && _groups$get !== void 0 ? _groups$get : {
            team: team,
            users: []
          };
          group.users.push(user);
          groups.set(teamId, group);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return Array.from(groups.values());
}
export function getCardWithAttendeePills(_ref) {
  var isTeamSelection = _ref.isTeamSelection,
    headingText = _ref.headingText,
    users = _ref.users,
    _ref$teams = _ref.teams,
    teams = _ref$teams === void 0 ? [] : _ref$teams;
  return /*#__PURE__*/_jsxs(ShadedCard, {
    p: "s",
    children: [/*#__PURE__*/_jsx(Box, {
      mb: "s",
      children: /*#__PURE__*/_jsx(Heading, {
        as: "h2",
        size: "extra-small",
        children: headingText
      })
    }), isTeamSelection ? /*#__PURE__*/_jsx(Stack, {
      spacing: "s",
      children: groupConflictUsersByTeam(users, teams).map(function (_ref2) {
        var team = _ref2.team,
          users = _ref2.users;
        return /*#__PURE__*/_jsxs(Stack, {
          spacing: "xxs",
          children: [/*#__PURE__*/_jsx(TeamPill, {
            team: team
          }), /*#__PURE__*/_jsx(Box, {
            ml: "m",
            children: /*#__PURE__*/_jsx(InlineList, {
              spacing: "xxs",
              children: users.map(function (user) {
                return /*#__PURE__*/_jsx(UserPill, {
                  user: {
                    id: user.userId,
                    name: user.name,
                    is_deleted: false
                  }
                }, user.userId);
              })
            })
          })]
        }, team.id);
      })
    }) : /*#__PURE__*/_jsx(InlineList, {
      spacing: "xxs",
      children: users.map(function (user) {
        return /*#__PURE__*/_jsx(UserPill, {
          user: {
            id: user.userId,
            name: user.name,
            is_deleted: false
          }
        }, user.userId);
      })
    })]
  });
}